import {TSBeitragArt} from './enums/TSBeitragArt';
import {TSBeitragStatus} from './enums/TSBeitragStatus';
import {TSBeitragType} from './enums/TSBeitragType';
/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import TSAbstractEntity from './TSAbstractEntity';
import TSBankverbindung from './TSBankverbindung';
import {TSSerializable} from './TSSerializable';

export default class TSBeitrag extends TSAbstractEntity implements TSSerializable<TSBeitrag> {

    private _beitragType: TSBeitragType;

    private _beitragArt: TSBeitragArt;

    private _beitragStatus: TSBeitragStatus;

    private _beitrag: number;

    private _importiertAbzugEV: number | null;

    private _vorname: string;

    private _name: string;

    private _bankverbindung: TSBankverbindung;

    private _bemerkung: string;

    private _sachbearbeiterMaxUeberschritten: boolean;

    /*transient*/
    private _selected: boolean = false;

    public constructor() {
        super();
        this.beitragStatus = TSBeitragStatus.NICHT_FREIGEGEBEN;
    }

    deserialize(restObject: any): TSBeitrag {
        super.deserialize(restObject);
        this.beitragArt = restObject.beitragArt;
        this.beitragType = restObject.beitragType;
        this.beitragStatus = restObject.beitragStatus;
        this.beitrag = restObject.beitrag;
        this.importiertAbzugEV = restObject.importiertAbzugEV;
        this.vorname = restObject.vorname;
        this.name = restObject.name;
        this.bankverbindung = this.deserializeOrCreate(restObject.bankverbindung, new TSBankverbindung());
        this.bemerkung = restObject.bemerkung;
        this.sachbearbeiterMaxUeberschritten = restObject.sachbearbeiterMaxUeberschritten;
        return this;
    }

    public serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.beitragArt = this.beitragArt;
        restObject.beitragType = this.beitragType;
        restObject.beitragStatus = this.beitragStatus;
        restObject.beitrag = this.beitrag;
        restObject.importiertAbzugEV = this.importiertAbzugEV;
        restObject.vorname = this.vorname;
        restObject.name = this.name;
        restObject.bankverbindung = this.serializeOrInit(this.bankverbindung, restObject.bankverbindung);
        restObject.bemerkung = this.bemerkung;
        return restObject;
    }

    public static getDeserializer = (beitrag: any) => {
        return new TSBeitrag().deserialize(beitrag);
    };

    public static getSerializer = (beitrag: any) => {
        return beitrag.serialize(beitrag);
    };

    public get beitragArt(): TSBeitragArt {
        return this._beitragArt;
    }

    public set beitragArt(value: TSBeitragArt) {
        this._beitragArt = value;
    }

    public get beitrag(): number {
        return this._beitrag;
    }

    public set beitrag(value: number) {
        this._beitrag = value;
    }

    public get importiertAbzugEV(): number | null {
        return this._importiertAbzugEV;
    }

    public set importiertAbzugEV(value: number | null) {
        this._importiertAbzugEV = value;
    }

    public get vorname(): string {
        return this._vorname;
    }

    public set vorname(value: string) {
        this._vorname = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get bankverbindung(): TSBankverbindung {
        return this._bankverbindung;
    }

    public set bankverbindung(value: TSBankverbindung) {
        this._bankverbindung = value;
    }

    public get bemerkung(): string {
        return this._bemerkung;
    }

    public set bemerkung(value: string) {
        this._bemerkung = value;
    }

    public getFullname(): string {
        if (this.vorname) {
            return this.vorname + ' ' + this.name;
        }
        return this.name;
    }

    public getBeguenstigterName(): string {
        if (this._bankverbindung) {
            return this._bankverbindung.inhaberName;
        }
        return this.getFullname();
    }

    public get beitragStatus(): TSBeitragStatus {
        return this._beitragStatus;
    }

    public set beitragStatus(value: TSBeitragStatus) {
        this._beitragStatus = value;
    }

    public get selected(): boolean {
        return this._selected;
    }

    public set selected(value: boolean) {
        this._selected = value;
    }

    public get sachbearbeiterMaxUeberschritten(): boolean {
        return this._sachbearbeiterMaxUeberschritten;
    }

    public set sachbearbeiterMaxUeberschritten(value: boolean) {
        this._sachbearbeiterMaxUeberschritten = value;
    }

    public get beitragType(): TSBeitragType {
        return this._beitragType;
    }

    public set beitragType(value: TSBeitragType) {
        this._beitragType = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSBeitrag.ts